import { ComponentOptions } from "../../components/components/component";
import { TemplateComponent } from "../../components/components/templateComponent";
import K_Chart from "../templates/K_Chart";

export interface ChartOptions extends ComponentOptions {
    containerId?: string;
    searchContainerId?: string;
    bsc?: string;
    searchClasses?: string;
}

export class Chart extends TemplateComponent {

    options: ChartOptions;

    constructor(options: ChartOptions) {
        super(K_Chart, options);
    }

    preRender() {
        const options = this.options;

        options.containerId = options.containerId || this.id + "_Container";
        options.searchContainerId = options.searchContainerId || this.id + "_SearchContainer";
    }

    cleanSearchContainer() {
        var me = this;

        $("#" + me.options.searchContainerId + " > :not(#" + me.options.searchContainerId + "_Actions)").remove();
        $("#" + me.options.searchContainerId + "_Actions").empty();
        $(".k-popup[id^=" + me.options.id + "]").remove();
    }

}
